<script>
  import { createEventDispatcher } from 'svelte';

  import Button from '@components/Button.svelte';

  const dispatch = createEventDispatcher();

  export let sticky = false;
  export let mobile = false;
  export let withMobileFooter = false;
  export let withQuiz = false;

  const dispatchClicked = () => {
    dispatch('clicked');
  };
</script>

<style style="text/scss" lang="scss">
  // Styles for desktop-based add button:
  .floating-action-bar-bottom {
    position: fixed;
    bottom: 40px;
    display: flex;
    align-items: center;
    z-index: 4;
    left: calc(50% - 32px);
    &.with-quiz {
      left: calc(50% + 118px);
    }

    &.with-mobile-footer {
      bottom: 80px;
    }
  }

  // Styles for mobile-based add button:
  .m-add-rec-section-container {
    position: fixed;
    bottom: 25px;
    left: calc(50% - 45px);
    padding: 0px 15px;
    z-index: 10;

    &.with-mobile-footer {
      bottom: 144px;
      &.with-quiz {
        bottom: 130px;
      }
    }

    .m-add-rec-section-btn {
      width: 64px;
      height: 64px;
      display: flex;
      justify-content: center;
      align-items: center;
      border: none;
      position: relative;
      box-shadow: 0px 13px 40px rgba(168, 147, 249, 0.394586);
      margin: 0px;
      padding: 0px;
      border-radius: 20px;
      background: transparent;
      .m-add-rec-section-btn-background {
        backdrop-filter: blur(20px);
        -webkit-backdrop-filter: blur(20px);
        background: rgba(137, 107, 217, 0.5);
        position: absolute;
        top: 0px;
        left: 0px;
        right: 0px;
        bottom: 0px;
        border-radius: 20px;
        margin: 0px;
        padding: 0px;
      }
      svg {
        backdrop-filter: blur(0px);
        -webkit-backdrop-filter: blur(0px);
      }
      &:active,
      &:hover {
        background: #9784e0;
      }
    }
  }
</style>

{#if mobile}
  <div class="m-add-rec-section-container" class:with-mobile-footer={withMobileFooter} class:with-quiz={withQuiz}>
    <button class="m-add-rec-section-btn" on:click={dispatchClicked}>
      <div class="m-add-rec-section-btn-background" />
      <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M23.3333 12.6667H2" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M12.6667 2V23.3333" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </button>
  </div>
{:else}
  <div
    class="floating-action-bar-bottom"
    class:with-mobile-footer={withMobileFooter}
    class:with-quiz={withQuiz}
    style="display: flex">
    {#if sticky}
      <span>
        <Button
          text={`<svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M23.3333 12.6667H2" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/><path d="M12.6667 2V23.3333" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>`}
          style="height: 64px; width: 64px; font-weight: 400; box-shadow: 0px 3px
15px rgba(168,147,249,0.394586); margin-top: 0px; margin-bottom: 0px;"
          on:click={dispatchClicked} />
      </span>
    {:else}
      <span>
        <Button
          style="height: 64px; width: 100px; box-shadow: 0px 3px
15px rgba(168,147,249,0.394586); margin-top: 0px; margin-bottom: 0px; margin-left: -14px;"
          text="<i class='fa fa-plus'></i><span style='margin-left: 10px; font-size: 18px;'>Add</span>"
          on:click={dispatchClicked} />
      </span>
    {/if}
  </div>
{/if}
